import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";

export const kineticSolutionsSensorService = {
  getSensorList,
};

function getSensorList(){
  return (
    axios
      .get(
        `${apiEndpoint.kineticSolutionsSensors}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}
